import findIndex from "lodash/fp/findIndex";

class Controller {
  constructor() {
    "ngInject";
  }
  $onInit() {
    this.onStationChange = (type) => {
      const stationLength = this.stations.length - 1;
      const getPickupIndex = (station) => station._id === this.pickup;
      const getDropoffIndex = (station) => station._id === this.dropoff;
      const pickupIndex = findIndex(getPickupIndex)(this.stations);
      const dropoffIndex = findIndex(getDropoffIndex)(this.stations);

      if (type === "pickup") {
        if (pickupIndex >= stationLength || pickupIndex < dropoffIndex) {
          this.invalidPickup = true;
        } else {
          this.invalidPickup = false;
        }
      } else if (type === "dropoff") {
        if (dropoffIndex <= pickupIndex || dropoffIndex === 0) {
          this.invalidDropoff = true;
        } else {
          this.invalidDropoff = false;
        }
      }
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/pickupDropoff/pickupDropoff.controller.js